/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaBillingNote } from '../../models/criteria-billing-note';
import { InvoiceWorklist } from '../../models/invoice-worklist';

export interface ApiBillingWorklistGetInvoiceWorklistPost$Params {
      body?: CriteriaBillingNote
}

export function apiBillingWorklistGetInvoiceWorklistPost(http: HttpClient, rootUrl: string, params?: ApiBillingWorklistGetInvoiceWorklistPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InvoiceWorklist>>> {
  const rb = new RequestBuilder(rootUrl, apiBillingWorklistGetInvoiceWorklistPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InvoiceWorklist>>;
    })
  );
}

apiBillingWorklistGetInvoiceWorklistPost.PATH = '/api/BillingWorklist/GetInvoiceWorklist';
